import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import { COUNTRY, COUNTRY_ALL, COUNTRY_CREATE, COUNTRY_DELETE, COUNTRY_LIST } from '../constants/actionTypes'
import * as API from '../constants/api'

export const country = createAsyncThunk(
  COUNTRY,
  async (params: PayloadCreatorParams<`${typeof API.COUNTRY}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.country(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const countryAll = createAsyncThunk(
  COUNTRY_ALL,
  async (params: PayloadCreatorParams<`${typeof API.COUNTRY_ALL}`, 'get'> | undefined, { rejectWithValue }) => {
    try {
      const response = await api.countryAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const countryCreate = createAsyncThunk(
  COUNTRY_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.COUNTRY}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.countryCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const countryDelete = createAsyncThunk(
  COUNTRY_DELETE,
  async (params: PayloadCreatorParams<`${typeof API.COUNTRY}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.countryDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const countryList = createAsyncThunk(
  COUNTRY_LIST,
  async (params: PayloadCreatorParams<`${typeof API.COUNTRY}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.countryList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const countryListClear = createAction(`${COUNTRY_LIST}/clear`)

export const countryAllClear = createAction(`${COUNTRY_ALL}/clear`)

export const countryClear = createAction(`${COUNTRY}/clear`)
